import {AnchorContainer} from "./elements/AnchorContainer";
import {BrandGrid} from "./elements/BrandGrid";
import {BrandIndexHeadline} from "./elements/BrandIndexHeadline";
import {ReferBack, defineCustomElement} from "@otto-ec/nav_patternsson";

function registerElement(Elem) {
    customElements.get(Elem.customElementName) || customElements.define(Elem.customElementName, Elem);
}

function main() {
    registerElement(AnchorContainer);
    registerElement(BrandGrid);
    registerElement(BrandIndexHeadline);

    defineCustomElement("nav-refer-back", ReferBack);
}

main();
